import '../../../1_templates_new/elements/js/elements.js';
import '../../../1_templates_new/blocks/js/search-autocomplete';
import '../../../1_templates_new/blocks/js/promo_tabs.js';
import '../../../1_templates_new/blocks/js/slider-products.js';
import '../../../1_templates_new/elements/js/btn-add-cart.js';
import '../../../1_templates_new/blocks/js/slider-news.js';
import '../../../1_templates_new/blocks/js/slider-product-view.js';
import '../../../1_templates_new/blocks/js/slider-reviews.js';
import '../../../1_templates_new/blocks/js/gallery_popup.js';
import '../../../1_templates_new/blocks/js/brands.js';
import '../../../1_templates_new/blocks/js/slider-compare-products.js';
import '../../../1_templates_new/elements/js/btn-add-favorite.js';
import '../../../1_templates_new/elements/js/btn-add-compare.js';
import '../../../1_templates_new/blocks/js/brands.js';

class Main {
	constructor() {
		this.selectors = {
			document: document,
			body: 'body',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

  }
}
new Main()
